import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatComponent } from 'src/app/model/cat-component.model';
import { CatComponentService } from 'src/app/services/cat-component.service';

@Component({
  selector: 'app-modal-cat-component',
  templateUrl: './modal-cat-component.component.html',
  styleUrls: ['./modal-cat-component.component.css']
})
export class ModalCatComponentComponent implements OnInit {
  @Input() component: CatComponent;
  @Input() mode: string;
  @Input() parentComponents: CatComponent[] = [];

  // estado pagina
  public viewStatus = 1;

  // opciones de tipo
  public componentTypes = [
    { value: 'configMenu', label: 'Menú de Configuración' },
    { value: 'functionsMenu', label: 'Menú de Funciones' }
  ];

  // iconos comunes (puedes ampliar esta lista)
  public commonIcons = [
    'icon-cog', 'icon-menu', 'icon-key', 'icon-users', 'icon-box',
    'icon-chart', 'icon-docs', 'icon-calendar', 'icon-money',
    'icon-database', 'icon-settings', 'icon-grid', 'icon-list'
  ];

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private catComponentService: CatComponentService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() { }

  //
  isValid = () => {
    let valid = true;
    let errors = [];
    if (!this.component.componentName || this.component.componentName.trim() === '')
      errors.push('El nombre del componente es requerido.');
    if (!this.component.componentURL || this.component.componentURL.trim() === '')
      errors.push('La URL del componente es requerida.');
    if (!this.component.componentType)
      errors.push('El tipo de componente es requerido.');
    if (!this.component.pathComponent || this.component.pathComponent.trim() === '')
      errors.push('El path del componente es requerido.');

    // Validar formato de URL (sin espacios, minúsculas, guiones permitidos)
    if (this.component.componentURL) {
      const urlPattern = /^[a-z0-9\/\-]+$/;
      if (!urlPattern.test(this.component.componentURL)) {
        errors.push('La URL debe contener solo minúsculas, números, guiones y barras (ej: administracion/menus).');
      }
    }

    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }

  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;

      const serviceCall = this.mode === 'create'
        ? this.catComponentService.save(this.component)
        : this.catComponentService.update(this.component);

      serviceCall
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El componente se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el componente.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar el componente.'));
          })
        )
        .subscribe();
    }
  }

  close = () => this.modalService.dismissAll();
}
